import { render, staticRenderFns } from "./ShowroomInviteMailPreview.vue?vue&type=template&id=23a312ae&scoped=true&"
import script from "./ShowroomInviteMailPreview.vue?vue&type=script&lang=js&"
export * from "./ShowroomInviteMailPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShowroomInviteMailPreview.vue?vue&type=style&index=0&id=23a312ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a312ae",
  null
  
)

export default component.exports